import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const [showActions, setShowActions] = useState(false);
  const [bulkCategory, setBulkCategory] = useState('');
  const [bulkWatermark, setBulkWatermark] = useState(false);

  const categoryOptions = [
    { value: 'movies-series', label: 'Artes de Filmes e Séries' },
    { value: 'bbb', label: 'Artes do Big Brother Brasil' },
    { value: 'brasileirao', label: 'Artes do Brasileirão' },
    { value: 'app-partnerships', label: 'Artes de Parcerias de Aplicativos' }
  ];

  const handleBulkAction = (action) => {
    if (action === 'change-category' && bulkCategory) {
      onBulkAction('change-category', { category: bulkCategory });
      setBulkCategory('');
    } else if (action === 'toggle-watermark') {
      onBulkAction('toggle-watermark', { enabled: bulkWatermark });
    } else if (action === 'delete') {
      if (window.confirm(`Tem certeza que deseja excluir ${selectedCount} item(ns)?`)) {
        onBulkAction('delete');
      }
    }
    setShowActions(false);
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] w-full max-w-2xl px-4">
      <div className="bg-card rounded-lg border border-primary glow-primary p-4 shadow-lg">
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <div className="flex items-center gap-3 flex-1">
            <div className="w-10 h-10 rounded-md bg-primary/10 flex items-center justify-center glow-primary flex-shrink-0">
              <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">
                {selectedCount} item(ns) selecionado(s)
              </p>
              <p className="text-xs text-muted-foreground">
                Escolha uma ação para aplicar
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              iconName="Settings"
              onClick={() => setShowActions(!showActions)}
            >
              Ações
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onClearSelection}
            >
              Limpar
            </Button>
          </div>
        </div>

        {showActions && (
          <div className="mt-4 pt-4 border-t border-border space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-xs font-medium text-foreground">
                  Alterar Categoria
                </label>
                <div className="flex gap-2">
                  <Select
                    options={categoryOptions}
                    value={bulkCategory}
                    onChange={setBulkCategory}
                    placeholder="Selecione"
                  />
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Check"
                    onClick={() => handleBulkAction('change-category')}
                    disabled={!bulkCategory}
                  >
                    Aplicar
                  </Button>
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-xs font-medium text-foreground">
                  Marca d'água
                </label>
                <div className="flex gap-2">
                  <select
                    value={bulkWatermark ? 'enable' : 'disable'}
                    onChange={(e) => setBulkWatermark(e?.target?.value === 'enable')}
                    className="flex-1 px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-smooth"
                  >
                    <option value="enable">Ativar</option>
                    <option value="disable">Desativar</option>
                  </select>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Check"
                    onClick={() => handleBulkAction('toggle-watermark')}
                  >
                    Aplicar
                  </Button>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-2">
              <Button
                variant="outline"
                size="sm"
                iconName="MoveUp"
                onClick={() => handleBulkAction('move-up')}
                fullWidth
              >
                Mover para Cima
              </Button>
              <Button
                variant="outline"
                size="sm"
                iconName="MoveDown"
                onClick={() => handleBulkAction('move-down')}
                fullWidth
              >
                Mover para Baixo
              </Button>
              <Button
                variant="destructive"
                size="sm"
                iconName="Trash2"
                onClick={() => handleBulkAction('delete')}
                fullWidth
              >
                Excluir
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkActionsBar;